import { salaryApi } from 'entities/salary/salary.api';
import { CreatePrepaymentDto, PrepaymentDto, SalaryEntryDto, UpdatePrepaymentDto } from '@sr/dto';
import { fetchReq } from 'shared/api/axios';
import { SALARY_BASE_URL } from 'shared/api/api';
import { salaryEntriesApi, SalaryEntryQuery } from '../salary-entries/salary-entries.api';

type CreatePrepaymentResponse = {
  salaryEntry: SalaryEntryDto,
}

export const prepaymentApi = salaryApi.injectEndpoints({
  endpoints: (builder) => ({
    createPrepayment: builder.mutation<CreatePrepaymentResponse, CreatePrepaymentDto>({
      invalidatesTags: ['salary-entries'],
      query: (dto: CreatePrepaymentDto) => ({
        url: 'prepayment',
        body: dto,
        method: 'POST',
      }),
      async onQueryStarted(
        { userId, year, month },
        { dispatch, queryFulfilled, getCacheEntry, getState }) {
        try {
          const { data } = await queryFulfilled;

          dispatch(
            salaryEntriesApi.util.updateQueryData('getSalaryEntries', { year, month, userId }, (draft) => {
              draft.push( data.salaryEntry );
            })
          );
        } catch (e){
          console.error(e);
        }
      }
    }),

    updatePrepayment: builder.mutation<SalaryEntryDto, UpdatePrepaymentDto>({
      invalidatesTags: ['salary-entries'],
      query: (dto: UpdatePrepaymentDto) => ({
        url: `prepayment/${dto.id}`,
        body: dto,
        method: 'PUT',
      }),
    }),

    deletePrepayment: builder.mutation<void, number>({
      invalidatesTags: ['salary-entries'],
      query: (entryId: number) => ({
        url: `prepayment/${entryId}`,
        method: 'DELETE'
      }),
    }),

    // То же, что и deletePrepayment, но с поддержкой изменения кэша на странице salary (бред)
    deleteSalaryPrepayment: builder.mutation<void, SalaryEntryQuery & {entryId: number}>({
      invalidatesTags: ['salary-entries'],
      query: ({ entryId }) => ({
        url: `prepayment/${entryId}`,
        method: 'DELETE'
      }),
      async onQueryStarted({ year, month, userId, entryId }, { dispatch, queryFulfilled }) {
        const patchResult = dispatch(
          salaryEntriesApi.util.updateQueryData('getSalaryEntries', { year, month, userId }, (draft) => {
            const index = draft.findIndex((entry) => entry.id === entryId);
            if (index !== -1) {
              draft.splice(index, 1);
            }
          })
        );
        try {
          await queryFulfilled;
        } catch (e) {
          patchResult.undo();
          console.error('RTK Query onQueryStarted error', e);
        }
      }
    })
  }),
});

export const fetchPrepayment = async (salaryEntryId: number) => {
  return await fetchReq<PrepaymentDto>(`${SALARY_BASE_URL}/prepayment/${salaryEntryId}`);
};
